import { useEffect, useState } from 'react';
// import { getData } from '../../utils/apiCalls';
import { TickerCounter } from '../TickerCounter';
import { useObserver } from '../../hooks/useObserver';
// import { Loader } from '../Loader';

export const StatsBanner = () => {
   // const [data, setData] = useState()
   const [wasVisible, setWasVisible] = useState(false)
   // const [isLoading, setIsLoading] = useState(true)

   const [containerRef, isVisible] = useObserver({
      root: null,
      rootMargin: "0px",
      threshold: 0.6
   })

   // useEffect(() => {
   //    getData(`https://youngstartup.io/api/cwebsite/get_speakers_dyn`)
   //       .then(res => { setData(res) })
   //       .then(() => { setIsLoading(false) })
   // }, [])

   useEffect(() => {
      setWasVisible(isVisible || wasVisible)
   }, [isVisible])

   const items = [
      { prefix: '', sufix: '+', number: 120, title: `120+`, content: 'Featured Investors' },
      { prefix: '', sufix: '+', number: 150, title: `150+`, content: 'Top Innovators' },
      { prefix: '$', sufix: 'B', number: 280, title: '$280B', content: 'Under management' },
      { prefix: '', sufix: '+', number: 1000, title: '1000+', content: 'Attendees' },
      { prefix: '', sufix: '', number: 2500, title: '2500', content: '1 on 1 Meetings' },
   ]

   return (
      <div className='stats-banner'>
         <h1>WHERE INNOVATION MEETS CAPITAL<sup>TM</sup></h1>
         {/* {isLoading && <Loader color='dark2' />} */}
         <main ref={containerRef}>
            {items.map((item, index) => {
               return (
                  <div key={index} className='stats-item'>
                     <div className='img-txt'>
                        {wasVisible && <h3>{item.prefix} <TickerCounter targetNumber={item.number} />{item.sufix}</h3>}
                        {/* <h3>{item.title}</h3> */}
                        <h6>{item.content}</h6>
                     </div>
                     <span>/</span>
                  </div>
               )
            })}
         </main>
      </div>
   )
}

